import experiments from './experiments.json';

// get an up-to-date experiments object with "make refresh-experiments"
export default experiments;
